import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { LOCATION_TYPE } from '../../../../common/constant'
import { ErrorMessage } from '../../../../common/errorMessage'
import { selectLocation } from '../../../../common/store/slice'
import { selectCriteria } from '../../../store/slice'
import { Dropdown } from './Dropdown'
import classes from './index.module.scss'
import { SelectedLocation } from './SelectedLocation'

const sortAlphabet = (a, b) => a?.name?.localeCompare(b?.name)

export const Location = ({ criteriaGroup, screeningIndicatorId }) => {
  const location = useSelector(selectLocation)
  const selectedData =
    useSelector(
      selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
    ) || []
  const isError = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'error']),
  )

  const { provinces, districts, wards } = useMemo(() => {
    const selectedProvinceIds = selectedData.map(
      (item) => item.Province.LocationId,
    )

    //provinces
    const provinces = Object.values(location)
      .sort(sortAlphabet)
      .reduce((acc, item) => {
        if (selectedProvinceIds.includes(item.id)) {
          return [item, ...acc]
        }
        return [...acc, item]
      }, [])

    //districts
    const districts = []
    selectedProvinceIds.forEach((provinceId) => {
      districts.push(
        ...Object.values(location[provinceId].children).sort(sortAlphabet),
      )
    })
    provinces.forEach((province) => {
      if (!selectedProvinceIds.includes(province.id)) {
        districts.push(
          ...Object.values(location[province.id].children).sort(sortAlphabet),
        )
      }
    })

    //ward
    const wards = []
    const selectedDistrictIds = selectedData.reduce(
      (acc, curr) => [
        ...acc,
        ...curr.Province.Districts.map((i) => i.LocationId),
      ],
      [],
    )
    selectedProvinceIds.forEach((provinceId) => {
      const districtIds = Object.values(location[provinceId].children)
        .sort(sortAlphabet)
        .map((i) => i.id)
      selectedDistrictIds.forEach((districtId) => {
        if (location[provinceId].children[districtId]) {
          wards.push(
            ...Object.values(
              location[provinceId].children[districtId].children,
            ).sort(sortAlphabet),
          )
        }
      })
      districtIds.forEach((districtId) => {
        if (!selectedDistrictIds.includes(districtId)) {
          wards.push(
            ...Object.values(
              location[provinceId].children[districtId]?.children || {},
            ).sort(sortAlphabet),
          )
        }
      })
    })
    provinces.forEach((province) => {
      if (!selectedProvinceIds.includes(province.id)) {
        const districts = Object.values(location[province.id].children).sort(
          sortAlphabet,
        )
        districts.forEach((district) => {
          wards.push(...Object.values(district.children).sort(sortAlphabet))
        })
      }
    })

    return { provinces, districts, wards }
  }, [location, selectedData])

  return (
    <Element className={classes.pb4}>
      <Element className="dFlex gap1">
        <Dropdown
          data={provinces}
          locationType={LOCATION_TYPE.PROVINCE}
          criteriaGroup={criteriaGroup}
          screeningIndicatorId={screeningIndicatorId}
        />
        <Dropdown
          data={districts}
          locationType={LOCATION_TYPE.DISTRICT}
          criteriaGroup={criteriaGroup}
          screeningIndicatorId={screeningIndicatorId}
        />
      </Element>
      <SelectedLocation
        criteriaGroup={criteriaGroup}
        screeningIndicatorId={screeningIndicatorId}
      />
      {isError && <ErrorMessage value="screening.REQUIRED_MESS" />}
    </Element>
  )
}
